import axios from "../../axios";

export const getCounterparty = async (accountId, aggregated = false) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/counterparty?reportReferenceId=${accountId}` : `/api/v3/analysis/counterparty?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
};